export const GET_CUSTOMINFO = 'GET_CUSTOMINFO';
export const GET_GLOBALCONFIG = 'GET_GLOBALCONFIG';
export const GET_REGIONS = 'GET_REGIONS';
export const GET_USERINFO = 'GET_USERINFO';


// WEBPACK FOOTER //
// ./src/store/mutation-types.js